module.exports = __webpack_public_path__ + "img/scale-ring-background.49cb78bf.png";